import { combineReducers } from "redux";

import {
  SEARCH_SIMULASI_TARIF_LOADING,
  SEARCH_SIMULASI_TARIF_SUCCESS,
  SEARCH_SIMULASI_TARIF_ERROR,
} from "../actions/simulasiTarifAction";
import {
  LIST_SHIPPER_GET_ERROR,
  LIST_SHIPPER_GET_LOADING,
  LIST_SHIPPER_GET_SUCCESS,
  TYPECONTAINER_GET_ERROR,
  TYPECONTAINER_GET_LOADING,
  TYPECONTAINER_GET_SUCCESS,
} from "actions/constant";
import { LIST_PORT_GET_LOADING } from "actions/purchaseAction";

const searchSimulasiTarifLoading = (state = false, action) => {
  switch (action.type) {
    case SEARCH_SIMULASI_TARIF_LOADING:
      return action.searchSimulasiTarifLoading;
    default:
      return state;
  }
};

const searchSimulasiTarifSuccess = (state = false, action) => {
  switch (action.type) {
    case SEARCH_SIMULASI_TARIF_SUCCESS:
      return action.searchSimulasiTarifSuccess;
    default:
      return state;
  }
};

const searchSimulasiTarifError = (state = false, action) => {
  switch (action.type) {
    case SEARCH_SIMULASI_TARIF_ERROR:
      return action.searchSimulasiTarifError;
    default:
      return state;
  }
};

const simulasiTarif = (state = [], action) => {
  switch (action.type) {
    case SEARCH_SIMULASI_TARIF_SUCCESS:
      return action.simulasiTarif;
    default:
      return state;
  }
};

const listShipperGetError = (state = false, action) => {
  switch (action.type) {
    case LIST_SHIPPER_GET_ERROR:
      return action.listShipperGetError;
    default:
      return state;
  }
};

const listShipperGetLoading = (state = false, action) => {
  switch (action.type) {
    case LIST_SHIPPER_GET_LOADING:
      return action.listShipperGetLoading;
    default:
      return state;
  }
};

const listShipperGetSuccess = (state = false, action) => {
  switch (action.type) {
    case LIST_SHIPPER_GET_SUCCESS:
      return action.listShipperGetSuccess;
    default:
      return state;
  }
};

const listShipper = (state = [], action) => {
  switch (action.type) {
    case LIST_SHIPPER_GET_SUCCESS:
      return action.listShipper;
    default:
      return state;
  }
};

const typecontainerGetError = (state = false, action) => {
  switch (action.type) {
    case TYPECONTAINER_GET_ERROR:
      return action.typecontainerGetError;
    default:
      return state;
  }
};

const typecontainerGetLoading = (state = false, action) => {
  switch (action.type) {
    case TYPECONTAINER_GET_LOADING:
      return action.typecontainerGetLoading;
    default:
      return state;
  }
};

const typecontainerGetSuccess = (state = false, action) => {
  switch (action.type) {
    case TYPECONTAINER_GET_SUCCESS:
      return action.typecontainerGetSuccess;
    default:
      return state;
  }
};

const typecontainers = (state = [], action) => {
  switch (action.type) {
    case TYPECONTAINER_GET_SUCCESS:
      return action.typecontainers;
    default:
      return state;
  }
};

const simulasiTarifReducer = combineReducers({
  searchSimulasiTarifLoading,
  searchSimulasiTarifSuccess,
  searchSimulasiTarifError,
  simulasiTarif,

  listShipperGetError,
  listShipperGetLoading,
  listShipperGetSuccess,
  listShipper,

  typecontainerGetError,
  typecontainerGetLoading,
  typecontainerGetSuccess,
  typecontainers,
});

export default simulasiTarifReducer;
